export default __webpack_public_path__ + "static/media/eventDashboard_ms.078aed77.svg";